/**
 * Save the confirmation information
 */
export const SAVE_CONFIRMATION = "SAVE_CONFIRMATION"
/**
 * Empty the confirmation information
 */
export const RESET_CONFIRMATION = "RESET_CONFIRMATION"
